<template>
    <div class="kv-site kv-main">
        <content class="kv-page">

          <!-- menu -->
          <section class="background-id_3m16 lahuni82" style=" position:relative;">
              <div class="position-relative kv-content">
                  <div class="header-container no-cover ">
                      <div class="kv-fixed-header navigation-position  menu-top" data-kv-scroll-offset="32">
                          <div class="container-fluid navigation">
                              <header data-dynamic-container-element="true">
                                  <div class="kv-background " style=" background-color: rgb(255,255,255);">
                                      <div class="kv-background-inner " data-image="background-image: url('images/menu.png');" style="background-image: url('images/menu.png');background-color: rgb(255,255,255);opacity: 0.5;"></div>
                                  </div>

                                  <div class="logo" data-dynamic-navigation-element="logo">
                                  </div>
                                  <MenuPrincipal />
                              </header>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <!-- titulo -->
          <section id="subMenu" class="background-id_0 tehulu61 rifijo58" style=" position:relative;">
            <div class="container titles">
              <div class="row">
                <div class="section-text col-lg-10 offset-lg-1">
                  <h2 data-type="text" class="section-title caption-title section-title--sm">
                    Áreas de Atuação
                  </h2>
                  <p class="section-subtitle section-subtitle--sm" data-type="text">
                    Confira nossas especialidades:
                  </p>
                </div>
              </div>
            </div>
          </section>

        <section class="background-id_0adjacent hagopy24" style=" position:relative;">
            <div class="kv-background " style=" background-color: rgb(249,249,249);">
                <div class="kv-background-inner " style="background-color: rgb(249,249,249);"></div>
            </div>

            <div class="position-relative kv-content">
                <div class="section section--sm">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 offset-lg-1 align-left kv-notify-inview section-text">
                                <p class="section-subtitle overline title--xs" data-type="text">ADMINISTRAÇÃO JUDICIAL<br>(RECUPERAÇÃO JUDICIAL E FALÊNCIAS)<span data-prop="subtitle" class="ck-editable-element" data-editable="basic" style="display:none;"></span></p>

                                <p class="section-description body--md mb-0" data-type="text">
                                    <font class="cstm-fnt" style="font-size: 80.01%;">A empresa de Administração judicial Elizangela de Oliveira é especializada em Recuperação Judicial e Falência atuando há mais de 10 anos como órgão auxiliar do juízo, priorizando a busca pelo conhecimento técnico
                                        e acadêmico para encaminhar os processos de maneira célere e eficaz. A empresa também investe em tecnologia para agilizar o andamento dos processos possuindo um&nbsp;software&nbsp;próprio de gestão para
                                        possibilitar a obtenção de documentos e informações sobre os processos em andamento.</font><span data-prop="description" class="ck-editable-element" data-editable="basic" style="display:none;"></span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="background-id_0 hagopy24" style=" position:relative;">
            <div class="kv-control-placeholder kv-_section" data-kv-control="background"></div>
            <div class="kv-background " style=" background-color: rgb(255,255,255);">
                <div class="kv-background-inner " style="background-color: rgb(255,255,255);"></div>
            </div>

            <div class="position-relative kv-content">
                <div class="section section--sm">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 offset-lg-1 align-left kv-notify-inview section-text">
                                <p class="section-subtitle overline title--xs" data-type="text">DIREITO DIGITAL E SEGURANÇA DA INFORMAÇÃO<span data-prop="subtitle" class="ck-editable-element" data-editable="basic" style="display:none;"></span></p>

                                <p class="section-description body--md mb-0" data-type="text">
                                    <font class="cstm-fnt" style="font-size: 80.01%;">Nosso time está alinhado com o Direito Digital se propondo aos estudos das discussões sobre a regulamentação dos sistemas informáticos, atuação negocial e econômica por meios eletrônicos, crescimento do comércio
                                        via internet no objetivo de atender as demandas advindas desta especialidade.</font><span data-prop="description" class="ck-editable-element" data-editable="basic" style="display:none;"></span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="background-id_0adjacent hagopy24" style=" position:relative;">
            <div class="kv-background " style=" background-color: rgb(249,249,249);">
                <div class="kv-background-inner " style="background-color: rgb(249,249,249);"></div>
            </div>

            <div class="position-relative kv-content">
                <div class="section section--sm">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 offset-lg-1 align-left kv-notify-inview section-text">
                                <p class="section-subtitle overline title--xs" data-type="text">DIREITO PREVIDENCIÁRIO<span data-prop="subtitle" class="ck-editable-element" data-editable="basic" style="display:none;"></span></p>

                                <p class="section-description body--md mb-0" data-type="text">
                                    <font class="cstm-fnt" style="font-size: 80.01%;">Nosso escritório dispõe de uma equipe de advogados especializados na defesa dos trabalhadores em matéria previdenciária, tanto na esfera administrativa, junto ao INSS, quanto na esfera&nbsp;judicial, com o ingresso
                                        das ações&nbsp;&nbsp;cabíveis.</font><span data-prop="description" class="ck-editable-element" data-editable="basic" style="display:none;"></span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="kv-control-placeholder kv-_page" data-kv-control="5"></div>
        <section class="background-id_0 hagopy24" style=" position:relative;">
            <a name="section842"></a>
            <div class="kv-control-placeholder kv-_section" data-kv-control="background"></div>
            <div class="kv-background " style=" background-color: rgb(255,255,255);">

                <div class="kv-background-inner " style="background-color: rgb(255,255,255);"></div>

            </div>

            <div class="position-relative kv-content">
                <div class="section section--sm">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 offset-lg-1 align-left kv-notify-inview section-text">
                                <p class="section-subtitle overline title--xs" data-type="text">DIREITO CIVIL E DIREITO PROCESSUAL CIVIL<span data-prop="subtitle" class="ck-editable-element" data-editable="basic" style="display:none;"></span></p>

                                <p class="section-description body--md mb-0" data-type="text">
                                    <font class="cstm-fnt" style="font-size: 80.01%;">Nosso escritório conta com profissionais especializados para atuar nas mais diversas áreas do Direito Civil, na esfera extrajudicial e na propositura ou defesa das ações típicas da área de família e sucessões,
                                        ações envolvendo responsabilidade civil, direitos do consumidor, direito imobiliário, ações de cobrança e execuções, contratos em geral, ações securitárias (DPVAT e outros seguros).</font><span data-prop="description"
                                        class="ck-editable-element" data-editable="basic" style="display:none;"></span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="kv-control-placeholder kv-_page" data-kv-control="6"></div>
        <section class="background-id_0adjacent hagopy24" style=" position:relative;">
            <a name="section964"></a>
            <div class="kv-control-placeholder kv-_section" data-kv-control="background"></div>
            <div class="kv-background " style=" background-color: rgb(249,249,249);">

                <div class="kv-background-inner " style="background-color: rgb(249,249,249);"></div>

            </div>

            <div class="position-relative kv-content">
                <div class="section section--sm">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 offset-lg-1 align-left kv-notify-inview section-text">
                                <p class="section-subtitle overline title--xs" data-type="text">DIREITO DO TRABALHISTA<span data-prop="subtitle" class="ck-editable-element" data-editable="basic" style="display:none;"></span></p>

                                <p class="section-description body--md mb-0" data-type="text">
                                    <font class="cstm-fnt" style="font-size: 80.01%;">O escritório atua em âmbito consultivo e contencioso, para eliminação ou mitigação dos riscos trabalhistas. Ainda, promove a avaliação e a adequação de demandas que envolvam reclamações trabalhistas individuais
                                        ou coletivas, em sede de processos administrativos ou judiciais, com especial atenção ao cumprimento das normas.</font><span data-prop="description" class="ck-editable-element" data-editable="basic" style="display:none;"></span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="kv-control-placeholder kv-_page" data-kv-control="7"></div>
        <section class="background-id_0 qukefe53" style=" position:relative;">
            <a name="section1843"></a>
            <div class="kv-control-placeholder kv-_section" data-kv-control="background"></div>
            <div class="kv-background " style=" background-color: rgb(255,255,255);">

                <div class="kv-background-inner " style="background-color: rgb(255,255,255);"></div>

            </div>

            <div class="position-relative kv-content">
                <div class="section section--sm kv-notify-inview align-center">
                    <div class="container">
                        <div class="row v-center direction">
                            <div class="section-text column">



                            </div>
                            <div class="column button-group">
                                <router-link class="button-lg move-button undefined button-dynamic-buttons kv-button-instant-edit button-primary " data-index="0" data-type="button" tabindex="6" data-href="contato" to="/contato" data-property="buttons">


                                    <div class="button-has-title">Entre em contato<br>
                                        <div data-editable="button" data-prop="buttons.0.title" style="display:none;">
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

            <Footer />

        </content>
    </div>
</template>

<script>

import MenuPrincipal from '@/components/MenuPrincipal.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Areas',
    components: {
        MenuPrincipal, Footer
    }
}
</script>